var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "licensing-wrapper"
  }, [_c('h2', {
    staticClass: "title ps-0"
  }, [_vm._v("Licensing Verification")]), _vm._m(0), _c('div', {
    staticClass: "radio-section"
  }, [_vm._m(1), _c('div', {
    staticClass: "radio-group"
  }, [_c('label', {
    staticClass: "radio-option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.licenseStatus,
      expression: "licenseStatus"
    }],
    attrs: {
      "type": "radio",
      "name": "license_status",
      "value": "yes"
    },
    domProps: {
      "checked": _vm._q(_vm.licenseStatus, "yes")
    },
    on: {
      "change": function change($event) {
        _vm.licenseStatus = "yes";
      }
    }
  }), _c('span', {
    staticClass: "custom-radio-outer"
  }), _c('span', {
    staticClass: "label-text"
  }, [_vm._v(" Yes, I am a licensed insurance broker/agent ")])]), _c('label', {
    staticClass: "radio-option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.licenseStatus,
      expression: "licenseStatus"
    }],
    attrs: {
      "type": "radio",
      "name": "license_status",
      "value": "no"
    },
    domProps: {
      "checked": _vm._q(_vm.licenseStatus, "no")
    },
    on: {
      "change": function change($event) {
        _vm.licenseStatus = "no";
      }
    }
  }), _c('span', {
    staticClass: "custom-radio-outer"
  }), _c('span', {
    staticClass: "label-text"
  }, [_vm._v("No, I am not licensed")])])])]), _vm.licenseStatus === 'yes' ? _c('div', {}, [_c('div', {
    staticClass: "form-card"
  }, [_c('h4', [_vm._v("Add License Upload Details")]), _c('div', {
    staticClass: "form-grid"
  }, [_c('div', [_vm._m(2), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.state,
      expression: "state"
    }],
    staticClass: "custom-select",
    class: {
      'form-invalid': _vm.$v.state.$error
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v(" Select State")]), _vm._l(_vm.stateLists, function (state, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": state.value
      }
    }, [_vm._v(_vm._s(state.text))]);
  })], 2), !_vm.$v.state.required && _vm.$v.state.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" Field is required ")]) : _vm._e()]), _c('div', [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.licenseNumber,
      expression: "licenseNumber"
    }],
    class: {
      'form-invalid': _vm.$v.licenseNumber.$error
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter License Number"
    },
    domProps: {
      "value": _vm.licenseNumber
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.licenseNumber = $event.target.value;
      }, function ($event) {
        _vm.licenseNumber = _vm.licenseNumber.replace(/[^A-Za-z0-9]/g, '');
      }]
    }
  }), !_vm.$v.licenseNumber.required && _vm.$v.licenseNumber.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" Field is required ")]) : _vm._e()]), _c('div', [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.licenseValidUntil,
      expression: "licenseValidUntil"
    }],
    class: {
      'form-invalid': _vm.$v.licenseValidUntil.$error
    },
    attrs: {
      "type": "date",
      "min": _vm.minDate
    },
    domProps: {
      "value": _vm.licenseValidUntil
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.licenseValidUntil = $event.target.value;
      }
    }
  }), !_vm.$v.licenseValidUntil.required && _vm.$v.licenseValidUntil.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" Field is required ")]) : _vm._e(), !_vm.$v.licenseValidUntil.futureDate && _vm.$v.licenseValidUntil.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" Date must be in the future ")]) : _vm._e()]), _c('div', [_vm._m(5), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.resident,
      expression: "resident"
    }],
    staticClass: "custom-select",
    class: {
      'form-invalid': _vm.$v.resident.$error
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.resident = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Resident Status")]), _c('option', {
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("Yes")]), _c('option', {
    attrs: {
      "value": "no"
    }
  }, [_vm._v("No")])]), !_vm.$v.resident.required && _vm.$v.resident.$error ? _c('div', {
    staticClass: "form-error text-left ml-3 mt-2"
  }, [_vm._v(" Field is required ")]) : _vm._e()])]), _c('div', {
    staticClass: "upload-section"
  }, [_c('p', [_vm._v(" Upload License File (Max Size: 5MB, Allowed: jpg, png, pdf) ")]), _c('label', {
    staticClass: "upload-btn"
  }, [_vm._v(" Choose File "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "hidden": "",
      "accept": ".jpg,.jpeg,.png,.pdf"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })])]), _c('div', {
    staticClass: "d-flex justify-content-end mb-4"
  }, [_c('button', {
    staticClass: "button-submit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.uploadLicense
    }
  }, [_vm._v("Upload")])]), _vm.selectedFile ? _c('div', {
    staticClass: "selected-file-info mt-2 mb-3"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('p', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v("Selected file:")]), _vm._v(" " + _vm._s(_vm.selectedFile.name) + " "), _c('span', {
    staticClass: "file-size"
  }, [_vm._v("(" + _vm._s(_vm.formatFileSize(_vm.selectedFile.size)) + ")")])])]), _c('div', [_c('a', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "me-2",
    attrs: {
      "href": "#",
      "title": "Preview"
    },
    on: {
      "click": _vm.previewSelectedFile
    }
  }, [_c('i', {
    staticClass: "fas fa-eye"
  }), _vm._v(" Preview ")])])])]) : _vm._e(), _c('UploadedFileTable', {
    attrs: {
      "licenses": _vm.licenses
    },
    on: {
      "deleteLicense": _vm.deleteLicense
    }
  })], 1), _c('b-form-checkbox', {
    staticClass: "checkbox-default verify-checkbox mt-4",
    model: {
      value: _vm.certificationChecked,
      callback: function callback($$v) {
        _vm.certificationChecked = $$v;
      },
      expression: "certificationChecked"
    }
  }, [_c('p', {
    staticClass: "check-text"
  }, [_vm._v("I certify that the license(s) uploaded are valid, active, and issued in my name.")])])], 1) : _vm._e(), _vm.licenseStatus === 'yes' ? _c('Warning') : _vm._e(), _vm.licenseStatus === 'no' ? _c('ValidDisclaimer') : _vm._e(), _c('b-modal', {
    staticClass: "file-preview-modal",
    attrs: {
      "id": "file-preview-modal",
      "size": "lg",
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    },
    model: {
      value: _vm.showPreviewModal,
      callback: function callback($$v) {
        _vm.showPreviewModal = $$v;
      },
      expression: "showPreviewModal"
    }
  }, [_c('div', {
    staticClass: "preview-container"
  }, [_c('div', {
    staticClass: "preview-header"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.previewFileName))]), _c('button', {
    staticClass: "btn-close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePreviewModal
    }
  })]), _vm.previewUrl ? _c('div', {
    staticClass: "preview-body"
  }, [_vm.isImageFile ? _c('div', {
    staticClass: "image-preview"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.previewUrl,
      "alt": _vm.previewFileName
    }
  })]) : _vm.isPdfFile ? _c('div', {
    staticClass: "pdf-preview"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.previewUrl,
      "width": "100%",
      "height": "500px",
      "frameborder": "0"
    }
  })]) : _c('div', {
    staticClass: "no-preview"
  }, [_c('p', [_vm._v("Preview not available for this file type.")]), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.previewUrl,
      "download": _vm.previewFileName
    }
  }, [_vm._v("Download File")])])]) : _vm._e()])]), _c('div', {
    staticClass: "action-btn split-action mt-3"
  }, [_c('button', {
    staticClass: "button-back",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onBack
    }
  }, [_vm._v(" Back ")]), _c('div', {
    staticClass: "action-next"
  }, [_c('button', {
    staticClass: "button-save",
    attrs: {
      "type": "button",
      "disabled": !_vm.isNextButtonEnabled
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.saveAndContinue.apply(null, arguments);
      }
    }
  }, [_vm._v(" Save & Continue Later ")]), _c('button', {
    staticClass: "button-submit",
    class: {
      'button-disable': !_vm.isNextButtonEnabled
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.isNextButtonEnabled
    },
    on: {
      "click": _vm.onNext
    }
  }, [_vm._v("Next")])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "description"
  }, [_vm._v(" To continue your registration as a Representative with NuEra Benefits, you must confirm whether you are a currently licensed insurance "), _c('br'), _vm._v(" broker/agent. State and federal regulations require us to verify your active license before granting access to the Broker-Rep Back Office. ")]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "question"
  }, [_vm._v(" Are you a licensed insurance broker/agent? "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "label-title"
  }, [_vm._v("State "), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', [_vm._v("License Number "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', [_vm._v("License Valid Until "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', [_vm._v("Resident "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]);
}]

export { render, staticRenderFns }